import React from 'react';
import { motion } from 'framer-motion';
export function TrustBar() {
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.8,
    delay: 0.5
  }} className="w-full bg-carbon border-b border-dark-border py-4 px-4 overflow-hidden" data-id="element-176">
      <div className="max-w-5xl mx-auto flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-xs md:text-sm text-gray-sec font-medium tracking-wide" data-id="element-177">
        <span className="flex items-center gap-2" data-id="element-178">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-179"></span>
          +200 Techadores Confían en Nosotros
        </span>
        <span className="hidden md:inline text-dark-border" data-id="element-180">|</span>
        <span className="flex items-center gap-2" data-id="element-181">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-182"></span>
          Sistema Probado en 15 Ciudades
        </span>
        <span className="hidden md:inline text-dark-border" data-id="element-183">|</span>
        <span className="flex items-center gap-2" data-id="element-184">
          <span className="w-1.5 h-1.5 rounded-full bg-gold" data-id="element-185"></span>
          $2M+ en Contratos Generados
        </span>
      </div>
    </motion.div>;
}